import {
  GET_ALL_BANNERS,
  REMOVE_SINGLE_BANNER,
  ADD_NEW_BANNER,
  BANNERS_CURRENT_PAGE,
  BANNERS_TOTAL_PAGES,
} from "../../@jumbo/constants/ActionTypes";

export const setAllBannners = (banners) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_BANNERS,
      payload: banners,
    });
  };
};
export const addBanner = (banner) => {
  return (dispatch) => {
    dispatch({
      type: ADD_NEW_BANNER,
      payload: banner,
    });
  };
};
export const removeBanner = (banner) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_BANNER,
      payload: banner,
    });
  };
};
export const setBannerCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: BANNERS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};
export const setBannerTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: BANNERS_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};
